// ==============================================
// URL Parameter Applier (komplett angepasst)
// - setzt Radios per "echtem Klick" (damit Preview wirklich updatet)
// - wartet stabil bis UI/Preview ready (mehrere Versuche)
// - wendet Transform/Size an, aber lässt Farbe/Font primär über UI laufen
// - behält deine PDF-Link-Logik
// ==============================================

// Funktion zum Auslesen der URL-Parameter
function getUrlParameters() {
  const urlParams = new URLSearchParams(window.location.search);
  const params = {};
  for (const [key, value] of urlParams.entries()) params[key] = value;
  return params;
}

// Funktion zum sicheren Setzen von Input-Werten
function setInputValue(inputId, value) {
  const input = document.getElementById(inputId);
  if (input && value !== undefined && value !== null && value !== '') {
    input.value = value;
    input.setAttribute('value', value);

    // Trigger Events
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));

    return true;
  }
  return false;
}

// ------------------------------------------------
// RADIO: zuverlässig wählen (auch wenn Preview nur auf click reagiert)
// ------------------------------------------------
function triggerRadioSelection(radio) {
  if (!radio) return;

  // checked setzen
  radio.checked = true;

  // input/change Events
  radio.dispatchEvent(new Event('input', { bubbles: true }));
  radio.dispatchEvent(new Event('change', { bubbles: true }));

  // echter Klick: viele Picker hören nur auf click/pointer
  const label =
    (radio.id && document.querySelector(`label[for="${radio.id}"]`)) ||
    radio.closest('label') ||
    radio.parentElement ||
    radio.closest('.color-picker__item') ||
    radio.closest('.color-picker__grid') ||
    null;

  if (label && typeof label.click === 'function') {
    label.click();
  } else if (typeof radio.click === 'function') {
    radio.click();
  }
}

function applyRadioButtonParameters(params) {
  const radioMappings = {
    Schriftart: 'properties[Schriftart]',
    Schriftfarbe: 'properties[Schriftfarbe]',
    'Dekofarbe-1': 'properties[Dekofarbe-1]',
    'Dekofarbe-2': 'properties[Dekofarbe-2]',
    Motiv: 'properties[Motiv]',
  };

  Object.keys(radioMappings).forEach(paramKey => {
    const wantedValue = params[paramKey];
    if (!wantedValue) return;

    const radioName = radioMappings[paramKey];

    // Exakter Match (escaped)
    let radio = document.querySelector(
      `input[name="${radioName}"][value="${CSS.escape(String(wantedValue))}"]`
    );

    // Fallback: case-insensitive (z.B. "Orange" vs "orange")
    if (!radio) {
      const all = [...document.querySelectorAll(`input[name="${radioName}"]`)];
      radio = all.find(r => (r.value || '').toLowerCase() === String(wantedValue).toLowerCase());
    }

    if (!radio) {
      console.warn(`Radio Button nicht gefunden: ${radioName} mit Wert ${wantedValue}`);
      return;
    }

    if (!radio.checked) {
      triggerRadioSelection(radio);
      console.log(`Radio gesetzt: ${paramKey} = ${wantedValue}`);
    }
  });
}

// ------------------------------------------------
// TEXT: Position/Rotation/Size + Wunschtext
// (Farbe/Font werden primär durch die Radio-Klicks aktualisiert)
// ------------------------------------------------
function applyTextParameters(params) {
  const textPreview = document.getElementById('text-preview-3');
  if (!textPreview) {
    console.warn('text-preview-3 Element nicht gefunden');
    return;
  }

  let transform = '';
  let fontSize = '';

  // X
  if (params['text-x-achse-adjusted']) {
    setInputValue('x-input', params['text-x-achse-adjusted']);
    transform += `translateX(${params['text-x-achse-adjusted']}) `;
  }

  // Y
  if (params['text-y-achse-adjusted']) {
    setInputValue('y-input', params['text-y-achse-adjusted']);
    transform += `translateY(${params['text-y-achse-adjusted']}) `;
  }

  // Rotation
  if (params['text-rotate-adjusted']) {
    setInputValue('rotation-input', params['text-rotate-adjusted']);
    transform += `rotate(${params['text-rotate-adjusted']}) `;
  }

  // Font-size
  if (params['text-size-adjusted']) {
    setInputValue('text-size-adjusted', params['text-size-adjusted']);
    fontSize = params['text-size-adjusted'];
  }

  if (transform) {
    textPreview.style.setProperty('transform', transform.trim(), 'important');
  }
  if (fontSize) {
    textPreview.style.setProperty('font-size', fontSize, 'important');
  }

  // Wunschtext
  if (params['Wunschtext']) {
    const textInput = document.getElementById('text-input');
    if (textInput) {
      textInput.value = params['Wunschtext'];
      textInput.dispatchEvent(new Event('input', { bubbles: true }));
      textInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    textPreview.textContent = params['Wunschtext'];
  }
}

// ------------------------------------------------
// MOTIV: Position/Rotation/Size
// ------------------------------------------------
function applyMotivParameters(params) {
  const svgPreview = document.querySelector('.preview_image-svg');
  if (!svgPreview) {
    console.warn('.preview_image-svg Element nicht gefunden');
    return;
  }

  let transform = '';

  // X
  if (params['Motiv_x_achse_adjusted']) {
    setInputValue('image-x-input', params['Motiv_x_achse_adjusted']);
    transform += `translateX(${params['Motiv_x_achse_adjusted']}) `;
  }

  // Y
  if (params['Motiv_y_achse_adjusted']) {
    setInputValue('image-y-input', params['Motiv_y_achse_adjusted']);
    transform += `translateY(${params['Motiv_y_achse_adjusted']}) `;
  }

  // Rotation
  if (params['Motiv_rotation_adjusted']) {
    setInputValue('image-rotation-input', params['Motiv_rotation_adjusted']);
    transform += `rotate(${params['Motiv_rotation_adjusted']}) `;
  }

  // Size
  if (params['Motiv_size_adjusted']) {
    setInputValue('image-size-adjusted', params['Motiv_size_adjusted']);
    const sizeValue = params['Motiv_size_adjusted'];

    svgPreview.setAttribute('width', sizeValue);
    svgPreview.setAttribute('height', sizeValue);
    svgPreview.style.setProperty('width', sizeValue, 'important');
    svgPreview.style.setProperty('height', sizeValue, 'important');
  }

  if (transform) {
    svgPreview.style.setProperty('transform', transform.trim(), 'important');
  }
}

// ------------------------------------------------
// PDF-Link nur anzeigen wenn Custom-Params vorhanden
// ------------------------------------------------
function showPdfLinkIfParametersExist(params) {
  const pdfLinkElement = document.getElementById('pdf_link');
  if (!pdfLinkElement) {
    console.warn('Element mit ID "pdf_link" nicht gefunden');
    return;
  }

  const customParams = [
    'text-x-achse-adjusted',
    'text-y-achse-adjusted',
    'text-rotate-adjusted',
    'text-size-adjusted',
    'Motiv_x_achse_adjusted',
    'Motiv_y_achse_adjusted',
    'Motiv_rotation_adjusted',
    'Motiv_size_adjusted',
    'Wunschtext',
    'Schriftart',
    'Schriftfarbe',
    'Dekofarbe-1',
    'Dekofarbe-2',
    'Motiv',
  ];

  const hasCustomParams = customParams.some(param => params[param]);

  if (hasCustomParams) {
    pdfLinkElement.classList.add('input-visible');
  } else {
    pdfLinkElement.classList.remove('input-visible');
  }
}

// ------------------------------------------------
// OPTIONAL: Motiv marker (falls du das brauchst)
// ------------------------------------------------
function applyMotiv(params) {
  if (!params['Motiv']) return;
  const motivElement = document.querySelector('.preview_image-svg, .motiv-container');
  if (motivElement) motivElement.setAttribute('data-motiv', params['Motiv']);
}

// ------------------------------------------------
// Hauptfunktion
// WICHTIG: Reihenfolge + kleine Delays, damit UI erst reagiert
// ------------------------------------------------
function applyUrlParameters() {
  const params = getUrlParameters();

  console.log('=== URL-Parameter werden angewendet ===');
  console.log('Alle URL-Parameter:', params);

  showPdfLinkIfParametersExist(params);

  if (Object.keys(params).length === 0) return;

  try {
    // 1) Radios (per Klick) -> UI/Preview aktualisiert sich dadurch erst richtig
    applyRadioButtonParameters(params);

    // 2) leicht verzögert Transform/Size setzen, damit Inkybay Updates "durch" sind
    setTimeout(() => {
      applyTextParameters(params);
      applyMotivParameters(params);
      applyMotiv(params);

      console.log('=== Parameter erfolgreich angewendet ===');

      window.dispatchEvent(
        new CustomEvent('urlParametersApplied', {
          detail: params,
        })
      );
    }, 120);
  } catch (error) {
    console.error('Fehler beim Anwenden der Parameter:', error);
  }
}

// ------------------------------------------------
// Init mit mehreren Versuchen (weil Preview manchmal spät kommt)
// ------------------------------------------------
function initUrlParameterApplier() {
  let attempts = 0;
  const maxAttempts = 8;

  function tryApply() {
    attempts++;

    const textPreview = document.getElementById('text-preview-3');
    const svgPreview = document.querySelector('.preview_image-svg');

    // sobald irgendein Preview da ist, anwenden
    if (textPreview || svgPreview) {
      applyUrlParameters();
    } else if (attempts < maxAttempts) {
      setTimeout(tryApply, 400);
    } else {
      // letzter Versuch trotzdem
      applyUrlParameters();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(tryApply, 200));
  } else {
    setTimeout(tryApply, 200);
  }
}

// Script starten
initUrlParameterApplier();

// Öffentliche Funktionen
window.applyUrlParameters = applyUrlParameters;
window.getUrlParameters = getUrlParameters;
window.showPdfLinkIfParametersExist = showPdfLinkIfParametersExist;

// Debug
window.debugUrlParameters = function () {
  const params = getUrlParameters();
  console.log('=== URL PARAMETER DEBUG ===', params);

  const textPreview = document.getElementById('text-preview-3');
  const svgPreview = document.querySelector('.preview_image-svg');

  console.log('text-preview-3 gefunden:', !!textPreview);
  console.log('preview_image-svg gefunden:', !!svgPreview);

  if (textPreview) console.log('Text Preview Classes:', textPreview.className, 'Style:', textPreview.style.cssText);
  if (svgPreview) console.log('SVG Preview Style:', svgPreview.style.cssText);

  const pdfLinkElement = document.getElementById('pdf_link');
  console.log('PDF-Link Element gefunden:', !!pdfLinkElement);
  if (pdfLinkElement) console.log('PDF-Link Klassen:', pdfLinkElement.className);
};